if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        const forms = Array.from(document.querySelectorAll('.main-product-form'));
        const mainForm = forms.find(f => f.offsetParent !== null || f.getBoundingClientRect().height > 0) || forms[0];
        this.productFormActions = mainForm ? mainForm.querySelector('.product-form__submit') || mainForm : null;

        const infos = Array.from(document.querySelectorAll('product-info'));
        this.mainProductInfo = infos.find(i => i.offsetParent !== null || i.getBoundingClientRect().height > 0) || infos[0];
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();

        this.optionChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        const skioPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
        const compactSkioPicker = this.mainProductInfo?.querySelector('.compact-skio-picker');
        if (skioPlanPicker || compactSkioPicker) {
          this.syncInitialSellingPlan();
          this.boundHandleSellingPlanUpdate = this.handleSellingPlanUpdate.bind(this);
          this.mainProductInfo.addEventListener('skio::update-selling-plan', this.boundHandleSellingPlanUpdate);
        }

        this.productForm?.addEventListener('submit', () => {
          if (skioPlanPicker || compactSkioPicker) this.syncSellingPlanFromMainForm(false);
        }, { capture: true });

        this.init();
        const initialVariantId = this.querySelector(this.selectors.variantIdSelect)?.value;
        if (initialVariantId) {
          this.currentVariant = this.variantData.find((v) => v.id === Number(initialVariantId));
        }
        if (skioPlanPicker || compactSkioPicker) {
          this.syncInitialSellingPlan();
        } else if (this.currentVariant) {
          this.updatePrice();
        }

        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
          this.syncSellingPlanFromMainForm();
        });
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => { });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = !entry.isIntersecting ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 0, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.productForm;
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      disconnectedCallback() {
        if (this.optionChangeUnsubscriber) {
          this.optionChangeUnsubscriber();
        }
        if (this.mainProductInfo && this.boundHandleSellingPlanUpdate) {
          this.mainProductInfo.removeEventListener('skio::update-selling-plan', this.boundHandleSellingPlanUpdate);
        }
      }

      setStickyBarPrice(formattedPrice) {
        if (!formattedPrice) return;
        const containers = this.container?.querySelectorAll('.product-price-container');
        if (containers) containers.forEach((el) => { el.textContent = formattedPrice; });
      }

      getDisplayPriceFromMainForm() {
        const main = this.mainProductInfo;
        if (!main) return '';
        const compactPickers = Array.from(main.querySelectorAll('.compact-skio-picker'));
        const activeCompactPicker = compactPickers.find(el => el.offsetParent !== null || el.getBoundingClientRect().height > 0) || compactPickers[0];
        if (activeCompactPicker) {
          const compactSelect = activeCompactPicker.querySelector('select[id^="compact-skio-select-"]');
          if (compactSelect) {
            const opt = compactSelect.options[compactSelect.selectedIndex];
            if (opt?.dataset?.formattedPrice) return opt.dataset.formattedPrice;
            if (opt?.textContent?.trim()) return opt.textContent.trim();
          }
        }
        const subPrice = main.querySelector('.subscription-price');
        if (subPrice) {
          const compareEl = subPrice.querySelector('.subscription-price-compare');
          if (compareEl) {
            const primary = subPrice.textContent.replace(compareEl.textContent, '').trim();
            if (primary) return primary;
          }
          if (subPrice.textContent?.trim()) return subPrice.textContent.trim();
        }
        const btnPrice = main.querySelector('.price-add-to-bag, [class*="subscription-price"]');
        if (btnPrice?.textContent?.trim()) return btnPrice.textContent.trim();
        return '';
      }

      updatePrice() {
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const fromMain = this.getDisplayPriceFromMainForm();
        if (fromMain) {
          this.setStickyBarPrice(fromMain);
          return;
        }
        const formatted = this.currentVariant
          ? FoxTheme.Currency.formatMoney(this.currentVariant.price, moneyFormat)
          : '';
        this.setStickyBarPrice(formatted);
      }

      syncInitialSellingPlan() {
        let stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
        if (!stickySellingPlanInput && this.productForm) {
          stickySellingPlanInput = document.createElement('input');
          stickySellingPlanInput.type = 'hidden';
          stickySellingPlanInput.name = 'selling_plan';
          this.productForm.appendChild(stickySellingPlanInput);
        }
        if (!stickySellingPlanInput) return;

        let sellingPlanId = '';
        let formattedPrice = '';

        const skioPlanPickers = Array.from(this.mainProductInfo?.querySelectorAll('skio-plan-picker') || []);
        const visibleSkioPlanPicker = skioPlanPickers.find(el => el.offsetParent !== null || el.getBoundingClientRect().height > 0);

        const compactPickers = Array.from(this.mainProductInfo?.querySelectorAll('.compact-skio-picker') || []);
        const visibleCompactPicker = compactPickers.find(el => el.offsetParent !== null || el.getBoundingClientRect().height > 0);

        const activeCompactPicker = visibleCompactPicker || (!visibleSkioPlanPicker && compactPickers[0] ? compactPickers[0] : null);
        const activeSkioPlanPicker = visibleSkioPlanPicker || (!activeCompactPicker && skioPlanPickers[0] ? skioPlanPickers[0] : null);

        if (activeCompactPicker) {
          const compactSelect = activeCompactPicker.querySelector('select[id^="compact-skio-select-"]');
          if (compactSelect) {
            sellingPlanId = compactSelect.value || '';
            const opt = compactSelect.options[compactSelect.selectedIndex];
            if (opt) {
              formattedPrice = opt.dataset?.formattedPrice || opt.textContent?.split('—').pop()?.trim() || '';
            }
          }
        } else if (activeSkioPlanPicker) {
          const mainSellingPlanInput = activeSkioPlanPicker.querySelector('input[name="selling_plan"]');
          sellingPlanId = mainSellingPlanInput?.value || '';
          const skioPriceEl = activeSkioPlanPicker.querySelector('.skio-price.selling-plan-price');
          formattedPrice = skioPriceEl?.textContent?.trim() || '';
        }

        stickySellingPlanInput.value = sellingPlanId;
        if (formattedPrice) {
          this.setStickyBarPrice(formattedPrice);
        } else {
          this.updatePrice();
        }
      }

      syncSellingPlanFromMainForm(updatePriceDisplay = true) {
        let stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
        if (!stickySellingPlanInput && this.productForm) {
          stickySellingPlanInput = document.createElement('input');
          stickySellingPlanInput.type = 'hidden';
          stickySellingPlanInput.name = 'selling_plan';
          this.productForm.appendChild(stickySellingPlanInput);
        }
        if (!stickySellingPlanInput) return;
        const skioPlanPickers = Array.from(this.mainProductInfo?.querySelectorAll('skio-plan-picker') || []);
        const visibleSkioPlanPicker = skioPlanPickers.find(el => el.offsetParent !== null || el.getBoundingClientRect().height > 0);

        const compactPickers = Array.from(this.mainProductInfo?.querySelectorAll('.compact-skio-picker') || []);
        const visibleCompactPicker = compactPickers.find(el => el.offsetParent !== null || el.getBoundingClientRect().height > 0);

        const activeCompactPicker = visibleCompactPicker || (!visibleSkioPlanPicker && compactPickers[0] ? compactPickers[0] : null);
        const activeSkioPlanPicker = visibleSkioPlanPicker || (!activeCompactPicker && skioPlanPickers[0] ? skioPlanPickers[0] : null);

        let sellingPlanId = '';

        if (activeCompactPicker) {
          const compactSelect = activeCompactPicker.querySelector('select[id^="compact-skio-select-"]');
          if (compactSelect) sellingPlanId = compactSelect.value || '';
        } else if (activeSkioPlanPicker) {
          const mainSellingPlanInput = activeSkioPlanPicker.querySelector('input[name="selling_plan"]');
          if (mainSellingPlanInput) sellingPlanId = mainSellingPlanInput.value || '';
        } else {
          const mainForm = this.mainProductInfo?.querySelector('form[is="product-form"]') ||
            this.mainProductInfo?.querySelector('form[action*="/cart/add"]');
          if (mainForm) {
            const mainInput = mainForm.querySelector('input[name="selling_plan"]') ||
              document.querySelector('input[name="selling_plan"][form="' + mainForm.id + '"]');
            if (mainInput) sellingPlanId = mainInput.value || '';
          }
        }
        stickySellingPlanInput.value = sellingPlanId;
        if (updatePriceDisplay) {
          const fromMain = this.getDisplayPriceFromMainForm();
          if (fromMain) this.setStickyBarPrice(fromMain);
        }
      }

      handleSellingPlanUpdate(event) {
        const d = event.detail || {};
        const sellingPlan = d.sellingPlan || (d.sellingPlanId != null ? { id: d.sellingPlanId } : null);
        const formattedPrice = d.formattedPrice;
        let stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
        if (!stickySellingPlanInput && this.productForm) {
          stickySellingPlanInput = document.createElement('input');
          stickySellingPlanInput.type = 'hidden';
          stickySellingPlanInput.name = 'selling_plan';
          this.productForm.appendChild(stickySellingPlanInput);
        }
        if (stickySellingPlanInput) {
          stickySellingPlanInput.value = sellingPlan?.id ? String(sellingPlan.id) : '';
        }
        if (formattedPrice) {
          this.setStickyBarPrice(formattedPrice);
        } else {
          this.updatePrice();
        }
      }

      updateSellingPlanAndPrice(sellingPlan, formattedPrice) {
        const stickySellingPlanInput = this.productForm?.querySelector('[name="selling_plan"]');
        if (stickySellingPlanInput) {
          stickySellingPlanInput.value = sellingPlan?.id ? String(sellingPlan.id) : '';
        }
        if (formattedPrice) this.setStickyBarPrice(formattedPrice);
      }

      handleOptionValueChange({ data: { event } }) {
        if (!this.mainProductInfo || !this.mainProductInfo.contains(event.target)) return;
        this.syncFromMainForm();
      }

      syncFromMainForm() {
        const mainSubmitButton = this.mainProductInfo?.querySelector('[id^="ProductSubmitButton-"]');
        if (!mainSubmitButton) return;

        const mainForm = mainSubmitButton.closest('form[is="product-form"]') ||
          this.mainProductInfo?.querySelector('form[is="product-form"]');
        if (!mainForm) return;

        const mainVariantInput = mainForm.querySelector('[name="id"]');
        const mainQuantityInput = mainForm.querySelector('[name="quantity"]');

        if (!mainVariantInput) return;

        const mainVariantId = mainVariantInput.value;
        const variantSelect = this.select;

        if (variantSelect) {
          const wasDifferent = variantSelect.value !== mainVariantId;

          this.isUpdating = true;

          variantSelect.value = mainVariantId;

          const option = variantSelect.querySelector(`option[value="${mainVariantId}"]`);
          if (option) {
            variantSelect.querySelectorAll('option').forEach(opt => opt.removeAttribute('selected'));
            option.setAttribute('selected', 'selected');
          }

          this.isUpdating = false;

          this.currentVariant = this.variantData.find((variant) => variant.id === Number(mainVariantId));

          if (wasDifferent && this.currentVariant) {
            this.updateQuantityInput();
          }
        }

        if (mainQuantityInput) {
          const stickyQuantityInput = this.productForm?.querySelector('[name="quantity"]');
          if (stickyQuantityInput && stickyQuantityInput.value !== mainQuantityInput.value) {
            stickyQuantityInput.value = mainQuantityInput.value;
          }
        }

        const isDisabled = mainSubmitButton.hasAttribute('disabled') ||
          mainSubmitButton.getAttribute('aria-disabled') === 'true';
        const buttonText = mainSubmitButton.textContent.trim();
        const isSoldOut = buttonText.toLowerCase().includes('sold out');

        if (this.currentVariant) {
          this.updateButton(isDisabled || isSoldOut, isSoldOut ? FoxTheme.variantStrings.soldOut : '');
        } else if (mainVariantInput) {
          this.updateButton(isDisabled || isSoldOut, isSoldOut ? FoxTheme.variantStrings.soldOut : '');
        }
        this.syncSellingPlanFromMainForm();
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          this.syncFromMainForm();

        });
      }
    }
  );
}
